/**
 * Decodifica le entità HTML in testo normale (es. &quot; → ", &#039; → ').
 * Utile per mostrare correttamente stringhe che arrivano dall'API già codificate.
 * @param {string} str - Stringa eventualmente con entità HTML
 * @returns {string} Stringa con caratteri decodificati
 */
export function decodeHtmlEntities(str) {
  if (str == null || typeof str !== 'string') return str;
  return str
    .replace(/&quot;/g, '"')
    .replace(/&#039;/g, "'")
    .replace(/&apos;/g, "'")
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&#(\d+);/g, (_, n) => String.fromCharCode(parseInt(n, 10)))
    .replace(/&#x([0-9a-fA-F]+);/g, (_, n) => String.fromCharCode(parseInt(n, 16)));
}
